module.exports = __webpack_public_path__ + "img/app-hls.42e1e834.webp";